import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const KIOSKSHOPLANDINGBLOCK_LEGACY_FIELD_ORDER = [
  { type: "heading", value: "Color" },
  "background_color",
  "item_background_color",
  "item_selected_background_color",
  "accent_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskShopLandingBlockDescriptor: _generatedKioskShopLandingBlockDescriptor,
  kioskShopLandingBlockBlocDefinition,
  kioskShopLandingBlockDashboardLayout,
  kioskShopLandingBlockConfig,
  kioskShopLandingBlockResolveConfig,
  kioskShopLandingBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Shop - Landing",
    componentType: "KioskShopLandingBlockComponent",
    category: "kiosk",
    description: "Kiosk Shop - Landing.",
    keywords: [],
    allowed_in: ["KioskShopPage"],
    sharedFields: {},
  },

  () => ({
    background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-500" },
      options: {
        label: "pages.blocks.kiosk-shop-landing.background-color.label",
      },
    }),
    item_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-300" },
      options: {
        label: "pages.blocks.kiosk-shop-landing.item-background-color.label",
      },
    }),
    item_selected_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-400" },
      options: {
        label:
          "pages.blocks.kiosk-shop-landing.item-selected-background-color.label",
      },
    }),
    accent_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-300" },
      options: {
        label: "pages.blocks.kiosk-shop-landing.accent-color.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-shop-landing.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-shop-landing.fieldset.list.label",
            fields: [
              "background_color",
              "item_background_color",
              "item_selected_background_color",
              "accent_color",
            ],
          },
        ],
      },
    ],
  }),
);

export function kioskShopLandingBlockDescriptor(): IBlockDescriptor;
export function kioskShopLandingBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskShopLandingBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskShopLandingBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedKioskShopLandingBlockDescriptor,
    kioskShopLandingBlockProperties,
    fieldOrder,
  );
}

export {
  kioskShopLandingBlockBlocDefinition,
  kioskShopLandingBlockDashboardLayout,
  kioskShopLandingBlockProperties,
  kioskShopLandingBlockConfig,
  kioskShopLandingBlockResolveConfig,
};

export type KioskShopLandingBlockConfig = typeof kioskShopLandingBlockConfig;
